
import { overrideStore, parametrize } from 'react-overridable';

import StudyResultsListItem from '@js/study/search/ResultsListItem';
import { RecordsList } from '@js/oarepo_ui/search/RecordsList';
import ExperimentResultsListItem from '@js/experiment/search/ResultsListItem';
const RecordsListWithProps = parametrize(RecordsList, { searchEndpoint: "/search" });

overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://study-v1.0.0.json', StudyResultsListItem);
overrideStore.add('InvenioAppRDM.RecordsList.layout', RecordsListWithProps);
overrideStore.add('InvenioAppRDM.RecordsList.ResultsList.item.local://experiment-v1.0.0.json', ExperimentResultsListItem);
